export const CHECK_MEASUREMENTS = 'CHECK_MEASUREMENTS';
export const INITIALIZE_MEASUREMENTS = 'INITIALIZE_MEASUREMENTS';
export const DELETE_MEASUREMENTS = 'DELETE_MEASUREMENTS';


